/*eslint-disable */
import { COORDINATES } from '../components/DocumentCollection/constants/documentCollection';
import { STORE_UUID, VIALSLIST } from '../components/VialMapping/constants';
import { EncodeQueryData } from '../helpers/miscHelpers';
import { config } from './config';
import { omsFetch } from './omsService';

function getSchedulerIncomingApiKey() {
  const urlToken = new URLSearchParams(window.location.search).get('token');
  return urlToken || sessionStorage.getItem('token') || '';
}

async function schedulerFetch(fwdRoute, fwdMethod, { body, accept = 'application/json' } = {}) {
  const headers = new Headers({
    Accept: accept,
    'Content-Type': 'application/json',
    incoming_api_key: getSchedulerIncomingApiKey(),
    'fwd-route': fwdRoute,
    'fwd-method': fwdMethod,
  });
  const fetchOptions = {
    method: 'POST',
    headers,
  };
  if (body !== undefined) {
    fetchOptions.body = body;
  }
  return fetch(`${config().apiHost}/api/cmp/route/scheduler-api`, fetchOptions);
}

export async function GetReasonsList() {
  const res = await schedulerFetch('/api/v1/task/reason/list/', 'GET');
  if (res.status === 200) {
    return res.json();
  }
  throw Error(res.status);
}

export async function GetVialBody(taskId) {
  const res = await schedulerFetch(
    `/api/v1/task/${taskId}/vial-details?uuid=${localStorage.getItem(STORE_UUID)}`,
    'GET',
  );
  if (res.status === 200) {
    return res.json();
  }
  throw Error(res.status);
}

export async function GetDocumentBody(requestId) {
  const res = await omsFetch(
    `/api/public/document/fetch-documents-by-request/${requestId}?uuid=${localStorage.getItem(STORE_UUID)}&request_id=${requestId}`,
    'GET',
    { serviceUserTag: false, emedicAuth: true },
  );
  if (res.status === 200) {
    return res.json();
  }
  throw Error(res.status);
}

export async function uploadDocument(documentId, requestId, uploadedFiles,coordinates_input) {
  const formData = new FormData();

  // Append uploaded files
  uploadedFiles.forEach((fileData) => {
    if (fileData?.keyName) {
      formData.append(fileData.keyName, fileData.file);
    } else {
      formData.append('file', fileData.file);
    }
  });

  const coordinates_v = coordinates_input?coordinates_input: JSON.parse(localStorage.getItem(COORDINATES));
  if (coordinates_v) {
    formData.append('latitude', coordinates_v?.lat);
    formData.append('longitude', coordinates_v?.lng);
  }
  localStorage.removeItem(COORDINATES);

  try {
    const res = await omsFetch(
      `/api/public/document/${documentId}/request/${requestId}/save-document?uuid=${localStorage.getItem(STORE_UUID)}&request_id=${requestId}`,
      'POST',
      { serviceUserTag: false, emedicAuth: true, body: formData },
    );

    if (res.status === 200) {
      return res.json();
    }

    const errorData = await res.json();
    throw new Error(`${errorData.error || 'Unknown error'}`);
  } catch (error) {
    console.error('Upload failed:', error);
    throw new Error(error);
  }
}

export async function skipDocument(documentId, requestId, reason) {
  const res = await omsFetch(
    `/api/public/document/${documentId}/request/${requestId}/skip-document?uuid=${localStorage.getItem(STORE_UUID)}&request_id=${requestId}`,
    'POST',
    {
      serviceUserTag: false,
      emedicAuth: true,
      body: JSON.stringify({ reason, longitude: 0, latitude: 0 }),
    },
  );
  if (res.status === 200) {
    return res.json();
  }
  throw Error(res.status);
}

export async function GetDocumentCollectionStatus(requestId, uuid) {
  const res = await omsFetch(
    `/api/public/document/fetch-document-collection-status/${requestId}?request_id=${requestId}&uuid=${uuid}`,
    'GET',
    { serviceUserTag: false, emedicAuth: true },
  );
  if (res.status === 200) {
    return res.json();
  }
  throw Error(res.status);
}

export async function UpdateVialBody(taskId, body, campId = '') {
  const res = await schedulerFetch(
    `/api/v1/task/${taskId}/vial-details?uuid=${localStorage.getItem(STORE_UUID)}${campId ? `&camp_id=${campId}` : ''}`,
    'PATCH',
    { body: JSON.stringify(body) },
  );
  if (res.status === 200) {
    return res.json();
  }
  const errorBody = await res.json();
  throw new Error(JSON.stringify(errorBody));
}

export async function CompleteTask({
  campId,
  emedicId,
  token,
  cityCode,
  body,
}) {
  const res = await omsFetch(
    `/api/public/camps/${campId}/emedic/${emedicId}/complete-task/`,
    'POST',
    {
      queryParams: { token, cityCode },
      serviceUserTag: false,
      body: JSON.stringify(body),
    },
  );
  if (res.status === 200) {
    return res.json();
  }
  const errorBody = await res.json();
  throw new Error(JSON.stringify(errorBody));
}

export async function GetTatBreachStatus(taskId) {
  const res = await schedulerFetch(
    `/api/v1/task/${taskId}/tat-breach?uuid=${localStorage.getItem(STORE_UUID)}`,
    'GET',
  );
  if (res.status === 200) {
    return res.json();
  }
  throw Error(res.status);
}

export async function ChangeVialType(taskId, accession_id, newvialType) {
  const res = await schedulerFetch(
    `/api/v1/task/${taskId}/vial-type?uuid=${localStorage.getItem(STORE_UUID)}`,
    'PATCH',
    {
      body: JSON.stringify({
        accession_id,
        vial_type_id: Number(newvialType),
      }),
    },
  );
  if (res.status === 200) {
    return res.json();
  }
  throw Error(res.status);
}

export async function SkipTest(
  taskId,
  accession_id,
  vialType,
  skippedTestList,
  skippedTestNames,
) {
  const res = await schedulerFetch(
    `/api/v1/task/${taskId}/skip-test?uuid=${localStorage.getItem(STORE_UUID)}`,
    'PATCH',
    {
      body: JSON.stringify({
        accession_id,
        test_id_list: skippedTestList,
        vial_type_id: Number(vialType),
        test_name_list: skippedTestNames,
        vial_name: VIALSLIST[Number(vialType) + 1],
      }),
    },
  );
  if (res.status === 200) {
    return res.json();
  }
  throw Error(res.status);
}

export async function PostFilterTask(taskId) {
  const paramUrl = EncodeQueryData({
    task_id: taskId,
    filter_name: 'emedic_force_cancelled',
  });
  const res = await schedulerFetch(`/api/v1/task/filter/item?${paramUrl}`, 'POST');
  if (res.status === 200) {
    return res.json();
  }
  const errorBody = await res.json();
  throw new Error(JSON.stringify(errorBody));
}

export async function GetCityFromLocation(lat, long) {
  const res = await schedulerFetch(
    `/api/v1/hub?lat=${lat}&long=${long}`,
    'GET',
    { accept: '*/*' },
  );
  if (res.status === 200) {
    return res.json();
  }
  throw Error('This location is not serviceable');
}
